import { Component, createRef } from "react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { SubscriptionValidation } from "namirasoft-payment";
import { NSQLogUsageGauges } from "namirasoft-quota-react";
import { NSLinkBlue, NSRow, NSSectionTitle, NSSpace, NSSpaceSizeType } from 'namirasoft-site-react';

import { LogLayout } from "../LogLayout";
import { LogProps } from "../LogProps";
import { ProductUUID } from "namirasoft-api-product";

interface UsagePageProps extends NSARouterMakerResult, LogProps { }
interface UsagePageState 
{
    validation?: SubscriptionValidation;
}

export default class UsagePage extends Component<UsagePageProps, UsagePageState>
{
    LogLayout_Ref = createRef<LogLayout>();
    constructor(props: UsagePageProps)
    {
        super(props);
        this.state = {};
    }
    override componentDidMount()
    {
        this.props.servers.log.log_group.Validation().then(validation =>
        {
            this.setState({ validation });
        }).catch(() => { });
    }
    override render()
    {
        return (
            <LogLayout
                ref={this.LogLayout_Ref}
                {...this.props}
                action={{
                    title: "Log Usage Report",
                    description: "This report shows how much of the logging service you’ve used so far. You can see the number of Log Groups, total logs read, and your quota reset time. Paid users also see usage-based cost graphs.",
                    menus: {}
                }}
            >
                <NSSectionTitle title="Usage Detail">
                    <NSSpace size={NSSpaceSizeType.MINI} />
                    <NSRow style={{ alignItems: "stretch" }}>
                        <NSQLogUsageGauges {...this.props} />
                    </NSRow>
                    <NSSpace size={NSSpaceSizeType.NORMAL} />
                    <NSRow>
                        {
                            this.state.validation && !this.state.validation.subscribed ?
                                <NSLinkBlue
                                    href="https://payment.namirasoft.com/offer/list/log/log"
                                    target="_blank"
                                >
                                    Subscribe Now
                                </NSLinkBlue>
                                :
                                <NSLinkBlue
                                    href={`https://quota.namirasoft.com/request/new/?product_id=${ProductUUID.NAMIRASOFT_LOG}`}
                                    target="_blank"
                                >
                                    Request to increase Quota
                                </NSLinkBlue>
                        }
                    </NSRow>
                </NSSectionTitle>
            </LogLayout>
        );
    }
}